import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ContentsOverviewComponent} from './contents-overview.component';

const routes: Routes = [
  {path: 'contents', component: ContentsOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ContentsOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-overview/contents-overview-routing.module.ts